import { render, staticRenderFns } from "./douyin.vue?vue&type=template&id=0a3945ca&scoped=true"
import script from "./douyin.vue?vue&type=script&lang=js"
export * from "./douyin.vue?vue&type=script&lang=js"
import style0 from "./douyin.vue?vue&type=style&index=0&id=0a3945ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3945ca",
  null
  
)

export default component.exports